/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Box, Typography } from "@mui/material";
import { IErrorMessage } from "../../models/common/ErrorMessage";

export const ErrorMessage = (props: IErrorMessage) => {
  return (
    <Typography variant="body2">
      <Box component="span" color="error.main" fontWeight="fontWeightBold">
        {props.message}
      </Box>
    </Typography>
  );
};
